import { Coordinates } from "../../Util/Math/Coordinates"
import { ControlledMenu, MenuItem, MenuRadioGroup, RadioChangeEvent, SubMenu } from "@szhsin/react-menu"
import { FretBoardNote } from "../FretBoard/FretBoardV2"
import { useCtrlFretBoardNote, useCtrlFretBoardSelectedNotes, useFretBoardNoteCtrlMenuCoordinates, useFretBoardNoteCtrlMenuDrawLines, useFretBoardNoteCtrlMenuIsOpen, useFretBoardNoteCtrlMenuRefresh, useFretBoardNoteCtrlMenuStore } from "./FretBoardNoteCtrlMenuStore"
import { FretBoardNoteCtrlMenuState } from "./FretBoardNoteCtrlMenuState"

export function FretBoardNoteCtrlMenu(){
    const coords:Coordinates = useFretBoardNoteCtrlMenuCoordinates()
    const refresh:Function = useFretBoardNoteCtrlMenuRefresh()
    const setIsOpen:Function = useFretBoardNoteCtrlMenuStore((state:FretBoardNoteCtrlMenuState)=>state.setIsOpen)
    const drawLines:Function = useFretBoardNoteCtrlMenuDrawLines()
    let note:FretBoardNote|null = useCtrlFretBoardNote()
    let selectedNotes:FretBoardNote[] = useCtrlFretBoardSelectedNotes()
    const modNotes = (modFunction:Function) => {
      if(note){
        const modNotes:FretBoardNote[] = Array.from(new Set(selectedNotes.concat(note)))
        modNotes.forEach((note:FretBoardNote)=>{modFunction(note)})
        refresh()
        setIsOpen(false)
      }
    }
    const hideNote = () => {
        modNotes( (note:FretBoardNote)=>{ note.visible = !note.visible; note.selected = false } )
    }
    const ghost = () => {
        modNotes( (note:FretBoardNote)=>{ note.ghosted = !note.ghosted; note.selected = false } )
    }
    const toggleIsRoot = () => {
      modNotes( (note:FretBoardNote)=>{ note.isRoot = !note.isRoot; note.selected = false } )
    }
    const setNoteColor = (color:string|null) => {
      modNotes( (note:FretBoardNote)=>{ note.color = color } )
    }
    const getIsRootLabel = () => {
      return (note?.isRoot) ? 'Unset as Root' : 'Set as Root'
    }
    const getHideShowLabel = () => {
      return (note?.visible) ? 'Hide' : 'Show'
    }
    const getGhostLabel = () => {
      return (note?.ghosted) ? 'Remove Ghosting' : 'Ghost'
    }
    return <div className={'note-ctrl-menu'}>
    <ControlledMenu
        anchorPoint={{x:coords.x,y:coords.y}}
        state={useFretBoardNoteCtrlMenuIsOpen() ? 'open' : 'closed'}
        direction="right"
        onClose={() => {setIsOpen(false)}}
      >
        <MenuItem onClick={ghost}>{getGhostLabel()}</MenuItem>
        <MenuItem onClick={hideNote}>{getHideShowLabel()}</MenuItem>
        <MenuItem onClick={toggleIsRoot}>{getIsRootLabel()}</MenuItem>
        <SubMenu label={'Color'}>
          <MenuRadioGroup value={note?.color} onRadioChange={(e:RadioChangeEvent)=>{setNoteColor(e.value)}}>
              <MenuItem type="radio" value={null}>Default</MenuItem>
              <MenuItem type="radio" value={'orange'}>Orange</MenuItem>
              <MenuItem type="radio" value={'green'}>Green</MenuItem>
              <MenuItem type="radio" value={'red'}>Red</MenuItem>
          </MenuRadioGroup>
        </SubMenu>
        {(selectedNotes.length > 1 && note?.selected) && <MenuItem onClick={()=>{drawLines()}}>Draw Lines</MenuItem>}
      </ControlledMenu>
    </div>
}